// header news ticker
$('#news_tcker_id').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  variableWidth: true,
});


// Testimonial Slider
$('.testimonial-row-1').slick({
  infinite: true,
  slidesToShow: 5,
  nav: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 900,
  dots: true,
  slidesToScroll: 1,
  responsive: [{
      breakpoint: 1300,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 993,
      settings: {
        slidesToShow: 3
      }
    },
      {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5
      }
    },
               {
     breakpoint: 375,
      settings: {
        slidesToShow: 1.2
      }
    }
  ]
});


$('.testimonial-row-2').slick({
  infinite: true,
  slidesToShow: 2.5,
  dots:false,
  autoplay:false,
  autoplaySpeed: 2000,
    prevArrow1:'<img class="prod_slider_prev" src="./assets/images/arrow_pink_l.svg" alt="img">',
  nextArrow1: '<img class="prod_slider_next" src="./assets/images/arrow_pink_r.svg" alt="img">',
  speed: 900,
  dots: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 2000,
      settings: {
        slidesToShow: 2.5
      }
    },
     {
      breakpoint: 1680,
      settings: {
        slidesToShow: 2.3
      }
    },
       {
      breakpoint: 1501,
      settings: {
        slidesToShow: 2.1
      }
    },
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 992,
      settings: {
          autoplaySpeed: 3000,
        slidesToShow: 1
      }
    },
      {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    {
     breakpoint: 576,
      settings: {
        slidesToShow: 1.3
      }
    },
     {
     breakpoint: 425,
      settings: {
        slidesToShow: 1.2
      }
    },
    {
     breakpoint: 375,
      settings: {
        slidesToShow: 1.2
      }
    }
  ]
});

// perfect section slider

$('.perfect_slider').slick({
  infinite: true,
  slidesToShow: 2.2,
  // prevArrow:'<i class="far fa-chevron-left prod_slider_prev"></i>',
  // nextArrow: '<div class="icon_arrow"><img src="https://cdn.shopify.com/s/files/1/0904/8100/0828/files/Arrow_1.svg?v=1749121075" alt="img"><span>Zie Ervaringen</span></div>',
  slidesToScroll: 1,
  centerMode: true,
  autoplaySpeed: 3000,
  speed: 1000,
  centerPadding: '30px',
  autoplay: false,

  responsive: [{
      breakpoint: 1680,
      settings: {
        slidesToShow: 2.2,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2.1,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5,
      }
    }
  ]
});



// comparison slider

var divisor = document.getElementById("divisor"),
  handle = document.getElementById("handle"),
  slider = document.getElementById("slider");

function moveDivisor() {
  handle.style.left = slider.value + "%";
  divisor.style.width = slider.value + "%";
}

window.onload = function () {
  moveDivisor();
};